import { related, sourceIds } from './guides__build-power.mdx';

export { sourceIds, related };
export const quickAnswer =
  'Build Power 是当前角色整体战斗强度的概括值。Update 1.4.0 后可以更直接地在 Loadout 界面查看；当敌人等级明显高于你的 Build Power 时，战斗会更困难。';

## Build Power 在哪里看？

Build Power（配装整体强度）用于概括当前角色的战斗强度。打开 Loadout，查看左下角数字。该更新把指标从较早的 Stats & Effects 位置移到更容易查看的地方。

## 为什么要看这个数值

遭遇战很困难时，不仅检查技能搭配，也检查成长进度。官方更新说明提到，面对等级高于自己的敌人时会更难战斗。

## 怎么提升 Build Power？

继续完成支线、探索和升级，回到 The Gap 时检查可用升级。这里不宣称经过实测的最快刷级路线。

## 新游戏加继承

战斗能力、天赋、异化物、武器升级以及生命和资源改善可继承；移动能力仍受剧情进度约束。网站[配装规划器](/build-planner)只记录选择，不读取或计算游戏强度。

## 1.4.0 更新变化

Loadout 中的显示属于便利性改善，更新还加入 New Game++。平台具体修复请查看下方官方说明。
